module.exports = __webpack_public_path__ + "f9d1b8227e1e67187cfc7bd126ae2f4e.svg";